/**
 * FeeType (đối tượng chịu phí) + TransType (hình thức chuyển tiền) — MISA Panda x Jetpay BankHub
 * Giá trị theo enum JetPay: FeeType 0-đơn vị chuyển, 1-đơn vị thụ hưởng; TransType 3-chuyển thường, 4-chuyển nhanh
 */
const JetpayFeeType = Object.freeze({
  SenderUnit: 0,    // Đơn vị chuyển tiền
  BeneficiaryUnit: 1, // Đơn vị thụ hưởng
});

const JetpayFeeTypeLabel = {
  [JetpayFeeType.SenderUnit]: 'Đơn vị chuyển tiền',
  [JetpayFeeType.BeneficiaryUnit]: 'Đơn vị thụ hưởng',
};

const JetpayTransType = Object.freeze({
  Normal: 3,   // Chuyển thường
  Fast: 4,     // Chuyển nhanh
});

const JetpayTransTypeLabel = {
  [JetpayTransType.Normal]: 'Chuyển thường',
  [JetpayTransType.Fast]: 'Chuyển nhanh',
};

const JetpayFeeTypeOptions = Object.entries(JetpayFeeTypeLabel).map(([value, text]) => ({
  value: Number(value),
  text,
}));

const JetpayTransTypeOptions = Object.entries(JetpayTransTypeLabel).map(([value, text]) => ({
  value: Number(value),
  text,
}));

export default {
  JetpayFeeType,
  JetpayFeeTypeLabel,
  JetpayFeeTypeOptions,
  JetpayTransType,
  JetpayTransTypeLabel,
  JetpayTransTypeOptions,
};
